import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const subscriptionSideBar: ThemeApp['appComponents']['subscriptionSideBar'] = {
  cardTable: {
    wrapper: {
      backgroundColor: themeUi.semantic.color.background.secondary50,
      borderRight: `1px solid ${themeUi.semantic.color.border.secondary300}`
    },
    cardsContainer: {
      padding: themeUi.core.space.space100,
      gap: themeUi.core.space.space100
    },

    card: {
      variants: {
        normal: {
          backgroundColor: themeUi.semantic.color.background.secondary50,
          borderTopColor: themeUi.semantic.color.border.secondary300,
          borderRightColor: themeUi.semantic.color.border.secondary300,
          borderBottomColor: themeUi.semantic.color.border.secondary300,
          borderLeftColor: themeUi.semantic.color.border.secondary300,
          borderRadius: '0.4rem'
        },
        selected: {
          backgroundColor: themeUi.semantic.color.background.primary0,
          borderTopColor: themeUi.semantic.color.border.primary400,
          borderRightColor: themeUi.semantic.color.border.primary400,
          borderBottomColor: themeUi.semantic.color.border.primary400,
          borderLeftColor: themeUi.semantic.color.border.primary400,
          borderRadius: '0.4rem'
        }
      },
      components: {
        cardMiddle: {
          regionText: {
            color: themeUi.semantic.color.text.secondary950
          }
        },
        cardHeader: {
          headerText: {
            color: themeUi.semantic.color.text.secondary600
          }
        },
        cardFooter: {
          databaseDetails: {
            borderRightColor: themeUi.semantic.color.border.secondary300
          },
          analyticText: {
            normalColor: themeUi.semantic.color.text.secondary700,
            selectedColor: themeUi.semantic.color.text.secondary700
          }
        }
      }
    },

    components: {
      cardTableHeader: {
        container: {
          backgroundColor: themeUi.semantic.color.background.secondary50,
          borderBottom: themeUi.semantic.color.border.secondary300
        }
      }
    },

    filter: {
      filterDropDown: {
        filterContainer: {
          borderLeft: themeUi.semantic.color.border.secondary300,
          borderRight: themeUi.semantic.color.border.secondary300
        }
      },
      filterBy: {
        categoryOptions: {
          color: themeUi.semantic.color.text.secondary950
        }
      }
    }
  }
};

export default subscriptionSideBar;
